import { render } from "./imageMessage.vue?vue&type=template&id=27c9cee9&scoped=true"
import script from "./imageMessage.vue?vue&type=script&lang=js"
export * from "./imageMessage.vue?vue&type=script&lang=js"

import "./imageMessage.vue?vue&type=style&index=0&id=27c9cee9&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c9cee9"]])

export default __exports__